<template>
  <v-text-field
    v-model.trim="localValue"
    label="Search name, email, testator ID or ID number"
    single-line
    hide-details
    :append-icon="icons.mdiMagnify"
    @click:append="commit"
    @click:clear="onClear"
    @keydown.enter.prevent="commit"
    @blur="commit"
  />
</template>

<script>
  export default {
    name: 'AdvisorSearchInput',
    props: {
      value: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        localValue: this.value || '',
      };
    },
    watch: {
      value(newVal) {
        this.localValue = newVal != null ? newVal : '';
      },
    },
    methods: {
      commit() {
        const trimmed = this.localValue.trim();
        this.$emit('search', trimmed);
      },
      onClear() {
        this.localValue = '';
        this.$emit('clear');
      },
    },
  };
</script>
